/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import SendIcon from '@material-ui/icons/Send';
import { toggleDialog, updateInvitationId } from '../../../redux/features/invitation/remove/invitation.remove.slice';
import {
  toggleDialog as toggleResendDialog,
  updateInvitationId as updateResendInvitationId,
} from '../../../redux/features/invitation/resend/invitation.resend.slice';
import { InvitationStatus } from '../../../redux/features/invitations/invitations.enum';
import store from '../../../redux/store';

const checkIfRowDisabled = row => row.status !== InvitationStatus.PENDING && row.status !== InvitationStatus.EXPIRED;

const resendEntry = row => ({
  id: 'actions.row.resend',
  text: 'actions.invitation.resend',
  ariaLabel: 'actions.row.resend',
  tooltipText: 'actions.resend',
  icon: <SendIcon />,
  disabled: checkIfRowDisabled(row),
  active: true,
  onClick: (clickedRow) => {
    store.dispatch(updateResendInvitationId(clickedRow.id));
    store.dispatch(toggleResendDialog(true));
  },
});

const deleteEntry = row => ({
  id: 'actions.row.remove',
  ariaLabel: 'actions.row.remove',
  text: 'actions.invitation.remove',
  tooltipText: 'actions.remove',
  icon: <CloseIcon />,
  disabled: checkIfRowDisabled(row),
  active: true,
  onClick: (clickedRow) => {
    store.dispatch(updateInvitationId(clickedRow.id));
    store.dispatch(toggleDialog(true));
  },
});

export const computeCombinedCellEntries = (row) => {
  const entries = [resendEntry(row), deleteEntry(row)];
  return entries;
};
